import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table } from '@layout/ParticipantsTable';
import ParticipantsTableHead from './ParticipantsTableHead';
import ParticipantsTableRow from './ParticipantsTableRow';

export class ParticipantsTable extends PureComponent {
  static propTypes = {
    people: PropTypes.arrayOf(PropTypes.object),
  };

  static defaultProps = {
    people: [],
  };

  render() {
    const { people, setField, expandedId } = this.props;

    return (
      <div>
        <Table id="participants-table">
          <ParticipantsTableHead />
          <tbody>
            {people.length ? (
              people.map((item, i) => (
                <ParticipantsTableRow
                  key={item.id}
                  expandedId={expandedId}
                  setField={setField}
                  {...item}
                  arrayItemId={i}
                />
              ))
            ) : (
              <tr>
                <td colSpan={10} style={{ color: '#ccc', textAlign: 'center' }}>
                  No items to display
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default ParticipantsTable;



// WEBPACK FOOTER //
// ./components/organisms/ParticipantsTable/ParticipantsTable.js